import { IDeleteMedicaoUseCase } from "../../../presentation/useCases/delete/delete_medicao_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// DeleteMedicaoUseCase

export class DeleteMedicaoUseCase implements IDeleteMedicaoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async deleteMedicao(IdMedicaoTerceirizacao: number): Promise<void> {
    await this.repository.deleteMedicao(IdMedicaoTerceirizacao);
  }
}
